'use client';

/* eslint-disable no-nested-ternary */
import { useRef } from 'react';
import Image from 'next/image';
import { motion, useInView } from 'framer-motion';

function FeatureWorkContent({
  query,
  image,
  subTitle,
  title,
  items,
  description,
  subImage,
  t,
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    amount: 0.5,
    once: true,
    margin: '0px 0px -100px 0px',
  });

  const contentVariants = {
    hidden: {
      opacity: 0,
      transform: 'translateY(50px)', // 使用 transform 替代 y
    },
    visible: {
      opacity: 1,
      transform: 'translateY(0)',
      transition: {
        duration: 0.7,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1], // cubic-bezier 曲線，提供更順暢的動畫
      },
    },
  };
  const UpperTitle = subTitle ? subTitle.toUpperCase() : null;

  const generateAltText = (mainTitle, sub, des) => {
    if (mainTitle) {
      return `GoBuid ${mainTitle} interface`;
    }
    if (sub) {
      return `GoBuid ${sub} interface`;
    }
    if (des) {
      return `GoBuid feature interface`;
    }
    return 'GoBuid feature interface';
  };

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      variants={contentVariants}
      id={query}
      className="flex w-full scroll-mt-[130px] flex-col text-gray-900 md:flex-row md:items-center md:justify-between md:pt-0 md:odd:pl-20 md:even:flex-row-reverse md:even:pr-20 lg:scroll-mt-20"
      style={{
        willChange: 'transform, opacity', // 提示瀏覽器這些屬性會改變
      }}
    >
      <div className="md:flex-1">
        {title ? (
          <div className="pt-8 md:pt-20">
            <p className="text-xs lg:text-lg">{UpperTitle}</p>
            <h2 className="py-2 text-2xl font-600 lg:text-5xl lg:leading-[56px]">
              {title}
            </h2>
            {items ? (
              <ul className="py-1">
                {items.map((item) => (
                  <li
                    key={item}
                    className="flex gap-1 py-1 text-sm md:gap-2 lg:text-base"
                  >
                    <p className="text-[18px] lg:text-[30px]">▪️</p>
                    {t[item] ?? item}
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        ) : description ? (
          <div className="pb-2 lg:pb-0 lg:pl-20 lg:pt-0">
            <p className="text-sm lg:text-xl">{description}</p>
          </div>
        ) : (
          <ul className="py-1">
            {items.map((item) => (
              <li
                key={item}
                className="flex gap-1 py-1 text-sm md:gap-2 lg:text-base"
              >
                <p className="text-[18px] lg:text-[30px]">▪️</p>
                {t[item] ?? item}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="md:w-[57%]">
        <div className="flex w-full flex-col-reverse md:flex-row">
          {title ? (
            <div className="w-full md:pt-20">
              <Image
                src={image}
                alt={generateAltText(title, subTitle, description)}
                width={720}
                height={520}
                className="w-full"
                sizes="(min-width: 1360px) 684px, (min-width: 780px) 50.89vw, calc(100vw - 40px)"
              />
            </div>
          ) : (
            <div className="w-full">
              <Image
                src={subImage}
                alt={generateAltText(title, subTitle, description)}
                width={720}
                height={520}
                className="w-full"
                sizes="(min-width: 1360px) 684px, (min-width: 780px) 50.89vw, calc(100vw - 40px)"
              />
            </div>
          )}
        </div>
      </div>
    </motion.section>
  );
}

export default FeatureWorkContent;
